import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HeroTallModule } from '@challenger6/vm-pattern-library/hero';
import { AccordionModule } from '@challenger6/vm-pattern-library/accordion';
import { LinksGroupModule } from '@challenger6/vm-pattern-library/links-groups';
import { DividerLineModule } from '@challenger6/vm-pattern-library/divider-line/divider-line.module';
import { MediaModule } from '@challenger6/vm-pattern-library/media/media.module';
import { SelectableCardsModule } from '@challenger6/vm-pattern-library/selectable-cards/selectable-card.module';
import { FeatureCardModule } from '@challenger6/vm-pattern-library/feature-card/feature-card.module';
import { BreadcrumbModule } from '@challenger6/vm-pattern-library/breadcrumb/breadcrumb.module';
import { ButtonModule } from '@challenger6/vm-pattern-library/button/button.module';
import { TextInputModule } from '@challenger6/vm-pattern-library/text-input/text-input.module';
import { NotificationModule } from '@challenger6/vm-pattern-library/notification';

import { ConfirmationModule } from '@challenger/care/components/confirmation/confirmation.module';
import { PageHeadingModule } from '@challenger/care/components/page-heading/page-heading.module';
import { DidThisHelpdModule } from '@challenger/care/components/did-this-help/did-this-help.module';

import { SEOLandingPageShellComponent } from './containers/seo-landing-page-shell/seo-landing-page-shell.component';
import { SEOLandingPageRoutingModule } from './seo-landing-page-routing.module';

import { SEOStrapiService } from '../common/services/seo-strapi.service';

import { AccordionSectionComponent } from './components/accordion-section/accordion-section.component';
import { ArticleListingSectionComponent } from './components/article-listing-section/article-listing-section.component';
import { LinksGroupSectionComponent } from './components/links-group-section/links-group-section.component';
import { TabSectionComponent } from './components/tab-section/tab-section.component';
import { TextSectionComponent } from './components/text-section/text-section.component';
import { TileSectionComponent } from './components/tile-section/tile-section.component';
import { OrderedListSectionComponent } from './components/ordered-list-section/ordered-list-section.component';
import { FeatureArticleSectionComponent } from './components/feature-article-section/feature-article-section.component';
import { PostcodeCheckerSectionComponent } from './components/postcode-checker-section/postcode-checker-section.component';
import { MediaTilesSectionComponent } from './components/media-tiles-section/media-tiles-section.component';
import { FloatingBannerSectionComponent } from './components/floating-banner-section/floating-banner-section.component';
import { MarkdownComponent } from './components/markdown/markdown.component';
import { TileWithFAIconSmallSectionModule } from './components/tile-with-fa-icon-small-section/tile-with-fa-icon-small-section.module';

import { LatLongToPostcodeService } from '../billing/services/lat-long-to-postcode.service';
import { ModalModule } from '@challenger6/vm-pattern-library/modal';
import { SafeUrlPipe } from '../common/pipes/safe-url.pipe';
import { LoadingIndicatorModule } from '@challenger6/vm-pattern-library/loading-indicator';
import { DisableScrollDirective } from '../common/directives/disable-scroll.directive';
import { FlipCardComponent } from './components/countdown-section/flip-card/flip-card.component';
import { CountdownSectionComponent } from './components/countdown-section/countdown-section.component';
import { Base10Module } from '@virginmediao2/momentum-angular';
import { Upgrade360SectionComponent } from './components/upgrade-360-section/upgrade-360-section.component';

let assetsUrlPath = '/help/broadband/assets/';
if (window.location.hostname === 'localhost') {
  assetsUrlPath = '/assets/';
}

@NgModule({
  declarations: [
    SEOLandingPageShellComponent,
    AccordionSectionComponent,
    ArticleListingSectionComponent,
    FeatureArticleSectionComponent,
    LinksGroupSectionComponent,
    OrderedListSectionComponent,
    TabSectionComponent,
    TextSectionComponent,
    TileSectionComponent,
    PostcodeCheckerSectionComponent,
    Upgrade360SectionComponent,
    MediaTilesSectionComponent,
    MarkdownComponent,
    FloatingBannerSectionComponent,
    FlipCardComponent,
    CountdownSectionComponent,
    SafeUrlPipe,
  ],
  exports: [
    SEOLandingPageShellComponent,
    AccordionSectionComponent,
    ArticleListingSectionComponent,
    FeatureArticleSectionComponent,
    LinksGroupSectionComponent,
    OrderedListSectionComponent,
    TabSectionComponent,
    TextSectionComponent,
    TileSectionComponent,
    PostcodeCheckerSectionComponent,
    Upgrade360SectionComponent,
    MediaTilesSectionComponent,
    MarkdownComponent,
    FloatingBannerSectionComponent,
    FlipCardComponent,
    CountdownSectionComponent,
  ],
  imports: [
    CommonModule,
    SEOLandingPageRoutingModule,
    HeroTallModule.forRoot({ assetsUrl: assetsUrlPath.replace('assets/', '') }),
    MarkdownModule,
    AccordionModule,
    LinksGroupModule,
    TileWithFAIconSmallSectionModule,
    DividerLineModule,
    ConfirmationModule,
    DidThisHelpdModule,
    MediaModule,
    PageHeadingModule,
    BreadcrumbModule,
    SelectableCardsModule,
    FeatureCardModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    TextInputModule,
    NotificationModule,
    ModalModule,
    LoadingIndicatorModule,
    DisableScrollDirective,
    Base10Module,
  ],
  providers: [SEOStrapiService, LatLongToPostcodeService],
})
export class SEOLandingPageModule {}
